
<template>
  <div class="BSPFA"><!--需要修添加class-->
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;">
        
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('SingleTireStepAnalysis.title')}}</h1>
                <div class="machineSeach">
                  <label style="margin-right:10px">{{$t('SingleTireStepAnalysis.labelTitle')}}</label>
                  <span>{{machineidTitle}}</span>
                </div>
              </div>
              <!-- 页面主体部分-->
              <div class="my">
              <!-- 我的 -->
                <div class="tableWrap"> 
                    <!-- 表格 -->
                    <el-table
                      v-loading="loading"
                      :data="tableData"
                      style="width: 100%"
                      :stripe='true'
                      :border='true'
                      >
                    <!-- 日期时间 -->
                      <el-table-column
                       
                        
                        class-name='merge'
                        :label="$t('PartsFaultAlarm.tableTitle1')"
                        width="160">
                        <template slot-scope="scope">
                         
                          <svg v-if="scope.row.iconColor === '1绿'" style="width:18px;height:18px;vertical-align:middle;" t="1574665043593" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5859" width="200" height="200" data-spm-anchor-id="a313x.7781069.0.i22"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#1afa29" opacity=".1" p-id="5860" data-spm-anchor-id="a313x.7781069.0.i18" class="selected"></path><path d="M532.741689 284.603733L781.653333 717.198222a22.755556 22.755556 0 0 1-19.717689 34.110578H262.052978a22.755556 22.755556 0 0 1-19.683556-34.178844L493.340444 284.535467a22.755556 22.755556 0 0 1 39.412623 0.068266z m-26.0096 110.546489a17.066667 17.066667 0 0 0-17.066667 17.066667v188.461511a17.066667 17.066667 0 0 0 17.066667 17.066667h10.376533a17.066667 17.066667 0 0 0 17.066667-17.066667V412.216889a17.066667 17.066667 0 0 0-17.066667-17.066667h-10.376533z m0 244.849778a17.066667 17.066667 0 0 0-17.066667 17.066667v10.387911a17.066667 17.066667 0 0 0 17.066667 17.066666h10.376533a17.066667 17.066667 0 0 0 17.066667-17.066666v-10.376534a17.066667 17.066667 0 0 0-17.066667-17.066666h-10.376533z" fill="#1afa29" p-id="5861" data-spm-anchor-id="a313x.7781069.0.i19" class="selected"></path></svg>
                          <svg v-else-if="scope.row.iconColor=== '1红'" style="width:18px;height:18px;vertical-align:middle;" t="1574665043593" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5859" width="200" height="200"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#d81e06" opacity=".1" p-id="5860"></path><path d="M532.741689 284.603733L781.653333 717.198222a22.755556 22.755556 0 0 1-19.717689 34.110578H262.052978a22.755556 22.755556 0 0 1-19.683556-34.178844L493.340444 284.535467a22.755556 22.755556 0 0 1 39.412623 0.068266z m-26.0096 110.546489a17.066667 17.066667 0 0 0-17.066667 17.066667v188.461511a17.066667 17.066667 0 0 0 17.066667 17.066667h10.376533a17.066667 17.066667 0 0 0 17.066667-17.066667V412.216889a17.066667 17.066667 0 0 0-17.066667-17.066667h-10.376533z m0 244.849778a17.066667 17.066667 0 0 0-17.066667 17.066667v10.387911a17.066667 17.066667 0 0 0 17.066667 17.066666h10.376533a17.066667 17.066667 0 0 0 17.066667-17.066666v-10.376534a17.066667 17.066667 0 0 0-17.066667-17.066666h-10.376533z" fill="#d81e06" p-id="5861"></path></svg>
                          <svg v-else-if="scope.row.iconColor === '2红'" style="width:18px;height:18px;vertical-align:middle;" t="1574664885183" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4902" width="200" height="200"><path d="M581.42 802.43a69.17 69.17 0 0 1-137.21 0h-96.35c4.62 87 76.84 156.34 164.95 156.34s160.34-69.35 165-156.34z" fill="#d81e06" p-id="4903" data-spm-anchor-id="a313x.7781069.0.i13" class="selected"></path><path d="M851.94 704.45l-81.74-83.4a29.68 29.68 0 0 1-8.47-20.76V428.54c0-66.41-26-129-73.24-176.22a251.8 251.8 0 0 0-55.63-42.06 121.41 121.41 0 1 0-238-1.76 251.5 251.5 0 0 0-58.82 43.82c-47.23 47.23-73.24 109.81-73.24 176.22v171.55a29.68 29.68 0 0 1-8.46 20.75l-81.68 83.4-0.2 0.21a71.76 71.76 0 0 0 51.6 121.65h576.31a71.76 71.76 0 0 0 51.57-121.65zM514.05 159.83a25.44 25.44 0 0 1 25 20.7 249.56 249.56 0 0 0-26.73-1.44q-11.65 0-23.13 1.08a25.45 25.45 0 0 1 24.86-20.34zM281.73 730.1l52.64-51.75c13.08-12.42 24.46-25.88 24.46-43.83v-206a153.45 153.45 0 0 1 306.9 0v206c0 17.76 12.23 33.1 24 44.56l52.94 51z" fill="#e98f36" p-id="4904" data-spm-anchor-id="a313x.7781069.0.i12" class=""></path></svg>
                          <svg v-else style="width:18px;height:18px;vertical-align:middle;" t="1574665380489" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7041" width="200" height="200"><path d="M581.42 802.43a69.17 69.17 0 0 1-137.21 0h-96.35c4.62 87 76.84 156.34 164.95 156.34s160.34-69.35 165-156.34z" fill="#1afa29" p-id="7042"></path><path d="M851.94 704.45l-81.74-83.4a29.68 29.68 0 0 1-8.47-20.76V428.54c0-66.41-26-129-73.24-176.22a251.8 251.8 0 0 0-55.63-42.06 121.41 121.41 0 1 0-238-1.76 251.5 251.5 0 0 0-58.82 43.82c-47.23 47.23-73.24 109.81-73.24 176.22v171.55a29.68 29.68 0 0 1-8.46 20.75l-81.68 83.4-0.2 0.21a71.76 71.76 0 0 0 51.6 121.65h576.31a71.76 71.76 0 0 0 51.57-121.65zM514.05 159.83a25.44 25.44 0 0 1 25 20.7 249.56 249.56 0 0 0-26.73-1.44q-11.65 0-23.13 1.08a25.45 25.45 0 0 1 24.86-20.34zM281.73 730.1l52.64-51.75c13.08-12.42 24.46-25.88 24.46-43.83v-206a153.45 153.45 0 0 1 306.9 0v206c0 17.76 12.23 33.1 24 44.56l52.94 51z" fill="#1afa29" p-id="7043"></path></svg>
                          
                          <span style="margin-left:10px;vertical-align:middle;">{{scope.row.startTime | formatDate}}{{'.'+scope.row.Millisecond}}</span>
                        </template>
                      </el-table-column>
                    <!-- Machine -->
                      <el-table-column
                          class-name='merge'
                          :label="$t('PartsFaultAlarm.tableTitle4')"
                          >
                          <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.machineZh}}</span>
                            <span v-else>{{scope.row.machineEn}}</span>
                          </template>
                      </el-table-column>
                    <!-- Code -->
                      <el-table-column
                          class-name='merge'
                          :label="$t('PartsFaultAlarm.tableTitle5')"
                          >
                          <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.msgZh}}</span>
                            <span v-else>{{scope.row.msgEn}}</span>
                          </template>
                      </el-table-column>
                    <!-- type -->
                      <el-table-column
                          class-name='merge'
                          :label="$t('PartsFaultAlarm.tableTitle2')"
                          >
                          <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.typeZh}}</span>
                            <span v-else>{{scope.row.typeEn}}</span>
                          </template>
                      </el-table-column>
                    <!-- Code/Description -->
                      <el-table-column
                           
                          class-name='merge'
                          :label="$t('PartsFaultAlarm.tableTitle3')"
                          >
                           <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.descriptionZh}}</span>
                            <span v-else>{{scope.row.descriptionEn}}</span>
                          </template>
                      </el-table-column>
                    <!-- Action -->
                      <el-table-column
                          class-name='merge'
                          :label="$t('PartsFaultAlarm.Action')"
                          >
                          <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.actionDesZh}}</span>
                            <span v-else>{{scope.row.actionDesEn}}</span>
                          </template>
                      </el-table-column>
                    <!-- End State -->
                      <el-table-column
                          class-name='merge'
                          :label="$t('PartsFaultAlarm.EndState')"
                          >
                          <template slot-scope="scope">
                            <span v-if="$store.state.lang===1">{{scope.row.endStateDesZh}}</span>
                            <span v-else>{{scope.row.endStateDesEn}}</span>
                          </template>
                      </el-table-column>
                    </el-table>
                </div>
              </div>
            </div>
        
        </el-scrollbar>
  </div>
</template>

<script>
import downloadIcon from "vue-material-design-icons/Download.vue"
import alertIcon from "vue-material-design-icons/Alert.vue"
import replyIcon from "vue-material-design-icons/Reply.vue"
//引入转换时间文件
import { formatDate } from '../assets/js/date.js'

export default {
  name: 'PFA001',
  components: {
    downloadIcon,
    alertIcon,
    replyIcon
  },
  data () {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      condition1: [],
      loading: true,
      //我的代码
      partName:'Kinetix 5700',//设备
      partNameArr:[{//设备下拉框
          value: '选项1',
          label: 'Kinetix 5700'
        }],
      // **************搜索参数
      selectTime: [],// 筛选时间
      startTime: '',
      endTime: '',
      // 选中的机械id
      machineId:'',
      sort: '',
      // 当前页数
      nowPage: 1,
      nowPageSize: 10,
      // Action 筛选条件
      action:'',
      baseDataAllAction:[],
      // EndState 筛选条件
      endState:'',
      baseDataAllEndState:[],
      // Type 筛选条件
      TypeName:'',
      baseDataAllAllTypeName:[],
      // 输入查询的内容
      input:'',
      // **************搜索参数
      //日期限制条件 
      pickerOptions: {
        onPick: ({minDate}) => {
            this.pickerMinDate = minDate.getTime()
          },
          disabledDate: (time) =>{
            if (this.pickerMinDate !== '') {
              const day7 = 7 * 24 * 3600 * 1000
              let maxTime = this.pickerMinDate + day7
              let minTime = this.pickerMinDate - day7
              return (time.getTime() > maxTime ||
                        time.getTime() < minTime)
            } else {
              return ''
            }
          }
      },
      //图标复选框选中状态
      checkList:[this.$t('PartsFaultAlarm.Faults'),this.$t('PartsFaultAlarm.Alarms')],
      // 表格数据
      tableData: [],
      // 总页数
      total:null,
      // 图表
      barChart: null,
      barChart2: null,
      // fal数据
      // faultData: [],
      seachLoading: false,
      // 图表
      myChart:null,
      myChart2:null,
      // fault(错误)数据
      faultData: [],
      // alarms(警告)数据
      alarmData: [],
      //选中的图标颜色
      faultsicon:false,
      alarmsicon:false,
      resetsicon:false,
      faultColor:'',
      alarmsColor:'',
      machineidTitle: '',
      defaultid: '',
      timer: '',
    }
  },
  mounted() {
    if(localStorage.getItem('isMarketAccount') === '1') {
      this.condition1 = [Number(this.$store.state.defaultShopId), Number(this.$store.state.defaultId)]
      this.machineId = Number(this.$store.state.defaultId)
    }
    this.$store.commit('authority' , this.$route.path)
    this.getId()
    this.selectIcons()
    if(this.$store.state.lang === 1){
      this.checkList = ['错误','警告']
    }else{
      this.checkList = ['Faults','Alarms']
    }
  },
  destroyed() {
    // clearInterval(this.timer)
  },
  methods: {
   getId(){
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/getBigscreenMachine'
      }).then(function(res){
        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.defaultid =res.data.machine.id
          _this.getEventRecord()
          _this.timing()
        }
      })
    },
    //定时刷新数据
    timing(){
      let _this = this
      this.timer=setInterval(function(){
        _this.getEventRecord()
      },120000)
    },
    //搜索按钮请求数据
    getEventRecord(){
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/selectPartsWarnLog',
        params:{
          language: _this.$store.state.lang,
          machineId: _this.defaultid, // 机器的id,
          typeValue:_this.TypeName, 
          descriptionValue:_this.input,  
          actionValue:_this.action,  
          endStateValue:_this.endState, 
          startTime: _this.startTime, // 开始时间
          endTime: _this.endTime, // 结束时间
          sort: _this.sort,//排序
          pageNum: _this.nowPage,
          pageSize: _this.nowPageSize,
          dataTypes: 1//状态：故障、警报
        }
      }).then(function(res){
          _this.total = res.data.total//页码数
          //获取图标状态
          if(JSON.stringify(res.data) !== "{}" && res.data.total!==0){
            res.data.rows.map(item =>{
              if(item.dataType === 1){

                if(item.typeEn !== null){
                  if(item.typeEn.indexOf('Faults Cleared') !== -1 ){
                    //出现过该字符串 绿
                    item.iconColor = '1绿'
                  }else{
                    //没有出现过 该字符串 红
                    item.iconColor = '1红'
                  }
                }

              }else if(item.dataType === 2){

                if(item.actionDesEn !== null){
                  if(item.actionDesEn.indexOf('Alarm off') !== -1 ){
                    //出现过该字符串 绿
                    item.iconColor = '2绿'
                  }else{
                    //没有出现过 该字符串 红
                    item.iconColor = '2红'
                  }
                }
              }
            })
          }
          _this.tableData = res.data.rows
          _this.machineidTitle = res.data.rows[0].machineZh
          //获取毫秒
          _this.tableData.forEach(item=>{
            let getMillisecond = new Date(item.startTime).getMilliseconds()
            if(getMillisecond<100){
              getMillisecond = '0'+ getMillisecond
            }else if(getMillisecond < 10){
              getMillisecond = '00'+ getMillisecond
            }
            item.Millisecond = getMillisecond
          })
          
          _this.loading = false
          
      }).catch(function () {
          _this.loading = false
      })
    },
    //选中的图标
    selectIcons(){
        if(this.checkList.indexOf(this.$t('PartsFaultAlarm.Faults')) === -1){
          this.faultsicon = false
        }else{
          this.faultsicon = true
        }
         if(this.checkList.indexOf(this.$t('PartsFaultAlarm.Alarms')) === -1){
          this.alarmsicon = false
        }else{
          this.alarmsicon = true
        }
        if(this.checkList.indexOf(this.$t('PartsFaultAlarm.Resets')) === -1){
          this.resetsicon = false
        }else{
          this.resetsicon = true
        }
        this.action = ''
        this.endState = ''
        this.TypeName = ''
    }
    
   
  },
  filters: {//转换时间发方法
    formatDate (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'yyyy/MM/dd hh:mm:ss')
    }
  }
}
</script>
<style scoped>

.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 35px;
}
.recordTitle{
  padding: 1.42rem 1.78rem;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 2.5rem;
}
.recordTitle h1{
  font-size: 1.5rem;
  color: #525f7f;
  display: inline-block;
}
.seach{
  padding: 15px 10px;
}
.seach button{
  float: right;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.recordTitle .machineSeach{
  float: right;
}
.machineSeach label, .machineSeach span{
    font-size: 1.4rem;
}
/* 我的样式 */
.recordTitle div a {
  margin-left: 20px;
  color: #6bb4df;
}
.selectGroup{
  width: 190px;
}
.selectGroup2{
  width: 120px;
}
.tableWrap{
  padding: 1.07rem 1.42rem;
}
.titleRow{
   display: flex;
    line-height: 40px;
}
.titleRow label{
  font-size: 12px;
  margin-left: 9.5px;
}
.datePick{
  margin: 25px 0;
}
.datePick .btns{
  float: right;
}
.typeIcon{
  color: #6772e5;
}
.pagination{
  text-align: center;
  margin-top: 35px;
}
.mcond{
  color:#808080
}
.info{
  color:#7948ea;
}
.alm{
  color:#f16a4d
}
.flt{
  color:#d43030;
}
.chartWrap{
  width: 100%;
  display: flex;
  margin: 15px 0;
}
.chartWrap div{
  width: 50%;
  height: 200px;
  margin: 0 5%;
}

.type-select-width{
    width: 170px;
}
.code-select-width{
    width: 300px;
}
.code-margin{
    margin-left: 10px;
}
.showself{
  display: flex;
  margin-left: 10px;
  height: 40px;
}
.ShowWord{
  line-height: 40px;
  margin-right: 10px;
}
.iconse{
  margin-left: 2px;
  font-size: 14px;
}
.faultsRed{
  color: #ff0000;
}
.faultsGreen{
  color: #6ff063;
}
.alarmsRed{
  font-weight: 800;
  color: #ff0000;
}
.alarmsGreen{
  font-weight: 800;
  color: #64f557;
  /* font-size: 16px; */
  /* color: #e6a23c; */
}
.iconcolor{
  color: #409EFF;
}
/* element-ui样式 */
.el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner{
    width: 400px;
}
.el-checkbox{
    margin: 0 0 0 5px;
}
.el-checkbox:nth-child(1){
    margin: 0;
}
.el-button--text{
    color: #808080;
    
}
.merge span,.merge .cell{
    font-size: 1.2rem;
}
</style>

